/* eslint-disable */

/** unique or primary key constraints on table "argo.material_marriage" */
export enum ArgoMaterialMarriageConstraint {
  /** unique or primary key constraint on columns "material_marriage_id" */
  MaterialMarriagePkey = 'material_marriage_pkey',
  /** unique or primary key constraint on columns "context_id", "data_element_id", "component_material_id", "assembly_material_id", "collection_id" */
  MaterialMarriageUnq = 'material_marriage_unq'
}

/** select columns of table "argo.material_marriage" */
export enum ArgoMaterialMarriageSelectColumn {
  /** column name */
  AssemblyMaterialId = 'assembly_material_id',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  ComponentMaterialId = 'component_material_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataElementId = 'data_element_id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialMarriageId = 'material_marriage_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Status = 'status',
  /** column name */
  StatusNote = 'status_note',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.material_marriage" */
export enum ArgoMaterialMarriageUpdateColumn {
  /** column name */
  AssemblyMaterialId = 'assembly_material_id',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  ComponentMaterialId = 'component_material_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataElementId = 'data_element_id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialMarriageId = 'material_marriage_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Status = 'status',
  /** column name */
  StatusNote = 'status_note',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

